import { ComponentsProps } from "@mui/material/styles";

import { getTestAutomationProps } from "~/helpers/test-automation-props";

export const getMuiDrawerDefaultProps = (): ComponentsProps["MuiDrawer"] =>
  getTestAutomationProps("drawer") as ComponentsProps["MuiDrawer"];
